export class Order {
  MERCHANT_NAME: string = null;
  MERCHANT_URL_RETURN: string = null;
  MERCHANT_LOGO: string = null;
  MERCHANT_TEL: string = null;
  MERCHANT_CEL: string = null;
  MERCHANT_EMAIL: string = null;
  ORDER_AMOUT: string = null;
  ORDER_CURRENCY: string = null;
  ORDER_REFERENCE: string = null;
  ORDER_CODE: string = null;
  ORDER_BRIEF: string = null;
  ORDER_METHOD: string = null;
  ORDER_TOKEN: string = null;
  ORDER_IVA: number = null;
  ORDER_ID: string = null;
  USER_DI: string = null;
  USER_TYPE_DI: string = null;
  USER_NAME: string = null;
  REDIRECT_TIMEOUT: string = null;
  WIZARD: boolean;
  EXPIRATION: string;
}

export class Transation {
  MERCHANT_NAME: string = null;
  MERCHANT_URL_RETURN: string = null;
  MERCHANT_LOGO: string = null;
  MERCHANT_TEL: string = null;
  MERCHANT_CEL: string = null;
  MERCHANT_EMAIL: string = null;
  ORDER_AMOUT: string = null;
  ORDER_CURRENCY: string = null;
  ORDER_REFERENCE: string = null;
  ORDER_BRIEF: string = null;
  ORDER_METHOD: string = null;
  ORDER_TOKEN: string = null;
  ORDER_IVA: number = null;
  WIZARD: boolean;
  EXPIRATION: string;
}

export class AuthorizationDesc {
  OrderID: string = null;
  OrderDesc: string = null;
  OrderEmail?: string = '';
}
